import googlePlay from '../assets/img/DownloadOnGooglePlay.svg';

export const DownloadOnGooglePlay = () => {
    return (
        <div onClick={() => {
            window.open('https://play.google.com/store/apps/details?id=com.obsessless.app', '_blank');
        }}>
            <img src={googlePlay} alt="Google Play" className="w-full h-full object-contain" />
        </div>
    );
};

